/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Popconfirm,
} from 'antd';
import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import {
  INFINITE_EXPIRY_DATE, QUANTITY, toISTDate, DEFAULT_CUR_ROUND_OFF
} from '@Apis/constants';
import invoiceActions from '../../../actions/invoiceActions';
import HideValue from '../RestrictedAccess/HideValue';
import ViewBatchCustomFields from '../ViewBatchCustomFields';

/**
 * @param withApproval
 */
class BatchesTable extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    this.state = {
      batchColumns: [
        {
          title: '',
          render: (record) => {
            const { expiryDays, uomInfo, org } = this.props;
            const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
            const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
            let shelfLife = 0;
            if (dayjs().isSameOrBefore(expiryMoment)) {
              shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
            }
            const shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));
            return (
              <div className="mobile-list__item">
                <H3Text text={`Batch# ${record?.custom_batch_number || record?.batch_number}`} className="mobile-list__item-number" />
                {/* {record?.lot_number && batchConfig?.lot_number_is_enabled && <H3Text text={`Lot# - ${record?.lot_number}`} className="mobile-list__item-info" />} */}
                {expiryDays >= 0 ? (
                  <H3Text
                    text={`Shelf Life# - ${shelfLifePct}% (${shelfLife} Days)`}
                    className="mobile-list__item-info"
                  />
                ) : ''}
                {record?.cost_price ? <H3Text text={`Cost Price# - ${record?.cost_price}`} className="mobile-list__item-info" /> : ''}
                {record?.mrp && batchConfig?.lot_number_is_enabled ? <H3Text text={`MRP# - ${record?.mrp}`} className="mobile-list__item-info" /> : ''}
                <H3Text text={`Quantity - ${QUANTITY(Math.abs(record?.quantity), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`} className="mobile-list__item-info" />
              </div>
            );
          },
          responsive: ['xs'],
          hidden: false,
        },
        {
          title: 'Batch#',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => {
            const { expiryDays, org, productInfo } = this.props;
            const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
            const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
            let shelfLife = 0;
            if (dayjs().isSameOrBefore(expiryMoment)) {
              shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
            }
            let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));
            if (dayjs(record.expiry_date).format('YYYY-MM-DD') === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
            return (
              <div style={{ paddingTop: '5px' }}>
                {record?.custom_batch_number || record?.batch_number}
                <div className="table-subscript">
                  {dayjs(record.expiry_date).format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE
                    && <H3Text text={`Expiry ${Helpers.batchDateFormatter(record?.expiry_date, productInfo?.expiry_date_format)}`} />}
                  {expiryDays > -1 && (
                    <div className="batch-shelf-life">
                      {dayjs(record.expiry_date).format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE && expiryDays !== -1 && (
                        <div
                          className="progress-line__wrapper"
                          style={{
                            width: '100px',
                            backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                          }}
                        >
                          <div
                            className="progress-line"
                            style={{
                              width: `${shelfLifePct}%`,
                              backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                            }}
                          />
                        </div>
                      )}
                      <span>
                        {(dayjs(record.expiry_date).format('YYYY-MM-DD') === INFINITE_EXPIRY_DATE || expiryDays === -1) ? 'No Expiry (100%)' : `${shelfLife} Days (${shelfLifePct}%)`}
                      </span>
                    </div>
                  )}
                  {record?.lot_number && batchConfig?.lot_number_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Lot#</span>
                        {' '}
                        {record?.lot_number}
                      </span>
                    )}
                    />
                  )}
                  {record?.ar_number && batchConfig?.ar_number_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>AR#</span>
                        {' '}
                        {record?.ar_number}
                      </span>
                    )}
                    />
                  )}
                  {record?.batch_barcode && batchConfig?.batch_barcode_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Barcode</span>
                        {' '}
                        {record?.batch_barcode}
                      </span>
                    )}
                    />
                  )}
                  {record?.batch_inward_date && batchConfig?.batch_inward_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Inward Date</span>
                        {' '}
                        {dayjs(record?.batch_inward_date).format('DD MMM, YY')}
                      </span>
                    )}
                    />
                  )}
                  {record?.roll_no && batchConfig?.roll_no_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Roll No#</span>
                        {' '}
                        {record?.roll_no}
                      </span>
                    )}
                    />
                  )}
                  {record?.brand && batchConfig?.brand_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Brand</span>
                        {' '}
                        {record?.brand}
                      </span>
                    )}
                    />
                  )}
                  {record?.mfg_batch_no && batchConfig?.mfg_batch_no_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg batch #</span>
                        {' '}
                        {record?.mfg_batch_no}
                      </span>
                    )}
                    />
                  )}
                  {record?.manufacturing_date && batchConfig?.manufacturing_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg Date</span>
                        {' '}
                        {Helpers.batchDateFormatter(record?.manufacturing_date, productInfo?.manufacturing_date_format)}
                      </span>
                    )}
                    />
                  )}
                  {record?.next_qc_date && batchConfig?.next_qc_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Next QC Date</span>
                        {' '}
                        {dayjs(record?.next_qc_date).format('DD MMM, YY')}
                      </span>
                    )}
                    />
                  )}
                  {record?.last_qc_date && batchConfig?.last_qc_date_is_enabled && (
                    <H3Text text={(
                      <span>
                        <span style={{ color: 'rgb(30, 30, 30)' }}>Last QC Date</span>
                        {' '}
                        {dayjs(record?.last_qc_date).format('DD MMM, YY')}
                      </span>
                    )}
                    />
                  )}
                </div>
                <div className="batch-list__item-created-by">
                  {record?.created_by_info ? `Issued by ${record?.created_by_info?.first_name} ${record?.created_by_info?.last_name?.charAt(0)} on ${toISTDate(record?.modified_at).format('DD MMM, YY')}` : ''}
                  {!record?.created_by_info ? `Issued on ${toISTDate(record?.modified_at).format('DD MMM, YY')}` : ''}
                </div>
              </div>
            );
          },
          width: '240px',
          hidden: false,
        },
        {
          title: 'Vendor',
          render: (text, record) => (
            <div>
              {record?.seller_id ? (
                <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                  <div className="company-name">
                    {record?.seller_name}
                  </div>
                </Link>
              ) : '-'}
            </div>
          ),
          hidden: !this.props.org?.organisation?.[0]?.inventory_config?.settings?.batch_management?.seller_name_is_enabled,
        },
        {
          title: 'Costing',
          render: (text, record) => {
            const { org } = this.props;
            const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
            return (
              <div className="table-subscript">
                {record?.mrp > 0 && batchConfig?.mrp_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>MRP</div>
                      <div>
                        {this.props.MONEY(record?.mrp)}
                      </div>
                    </div>
                  )}
                  />
                )}
                {record?.cost_price > 0 && batchConfig?.cost_price_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>Cost Price</div>
                      <div>
                        {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view cost price"} /> : this.props.MONEY(record?.cost_price)}
                      </div>
                    </div>
                  )}
                  />
                )}
                {record?.freight_cost > 0 && batchConfig?.freight_cost_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>Freight Cost</div>
                      <div>
                        {this.props.MONEY(record?.freight_cost)}
                      </div>
                    </div>
                  )}
                  />
                )}
                {record?.other_cost > 0 && batchConfig?.other_cost_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>Other Cost</div>
                      <div>
                        {this.props.MONEY(record?.other_cost)}
                      </div>
                    </div>
                  )}
                  />
                )}
                {record?.landed_cost > 0 && batchConfig?.landed_cost_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>Landed Cost</div>
                      <div>
                        {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view landed cost"} /> : this.props.MONEY(record?.landed_cost)}
                      </div>
                    </div>
                  )}
                  />
                )}
                {record?.selling_price > 0 && batchConfig?.selling_price_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>Selling Price</div>
                      <div>
                        {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view selling price"} /> : this.props.MONEY(record?.selling_price)}
                      </div>
                    </div>
                  )}
                  />
                )}
                {record?.margin > 0 && batchConfig?.margin_is_enabled && (
                  <H3Text text={(
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                    }}
                    >
                      <div style={{ color: 'rgb(30, 30, 30)' }}>Margin</div>
                      <div>
                      {parseFloat(Number(record?.margin).toFixed(DEFAULT_CUR_ROUND_OFF))}%
                      </div>
                    </div>
                  )}
                  />
                )}
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'Quality',
          render: (text, record) => (
            <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
              {record?.is_rejected_batch ? 'Bad' : 'Good'}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: false,
        },
        {
          title: 'Quantity',
          render: (text, record) => {
            const { uomInfo } = this.props;
            return (
              <div>{`${QUANTITY(Math.abs(record?.quantity), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: false,
        },
        {
          title: 'Location',
          render: (text, record) => (record?.inventory_location_path),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: !this.props.user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock,
        },
        {
          // title: 'Revert Stock',
          render: (text, record) => {
            const { revertStockForInvoice, callback } = this.props;
            const payload = {
              adjustments: [
                {
                  invoice_line_adjustment_id: record?.invoice_line_adjustment_id,
                },
              ],
            };
            return (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to revert the batch?"
                onConfirm={() => {
                  revertStockForInvoice(payload, () => {
                    callback();
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <div
                  className="generic-revert-button"
                  hidden={!record?.invoice_line_adjustment_id}
                  style={{
                    padding: '2px 0px 2px 12px',
                    width: '70px',
                  }}
                >
                  Revert
                </div>
              </Popconfirm>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: !this.props.revertStock,
        },
        {
          title: 'Custom Fields',
          render: (record) => <div style={{ minWidth: '140px' }}><ViewBatchCustomFields customFields={record?.custom_fields} /></div>,
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: false,
        },
      ].filter((item) => item.hidden !== true),
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      batches, title, isLoading, user, getOrgLoading, entity, revertStock,
    } = this.props;
    const { batchColumns } = this.state;
    return (
      <div className="batch-selector-wrapper">
        <H3Text text={title} className="batch-selector-title" />
        <Table
          size="small"
          columns={batchColumns}
          dataSource={batches}
          pagination={false}
          loading={isLoading || getOrgLoading}
          bordered
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers, InvoiceReducers
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  org: UserReducers.org,
  getOrgLoading: UserReducers.getOrgLoading,
  revertStockForInvoiceLoading: InvoiceReducers.revertStockForInvoiceLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  revertStockForInvoice: (payload, callback) => dispatch(invoiceActions.revertStockForInvoice(payload, callback)),
});

BatchesTable.propTypes = {
  expiryDays: PropTypes.any,
  batches: PropTypes.any,
  uomInfo: PropTypes.any,
  title: PropTypes.any,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchesTable));
